module.exports = __webpack_public_path__ + "img/Q1.977c0f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/Q1.png
// module id = ITNb
// module chunks = 0